import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sym from '../components/Sym';
import Logo2 from '../components/Logo2';
import ThemeToggle from '../components/ThemeToggle';
import { useTheme } from '../ThemeContext';

/**
 * Header del rediseño: nav sticky con logo, enlaces con subrayado activo,
 * toggle de tema (claro/auto/oscuro) y CTAs. Menú móvil con hamburguesa
 * (breakpoint 1024px, como pidió el diseño).
 */
const NAV = [
  { label: 'Inicio', to: '/' },
  { label: 'Características', to: '/caracteristicas' },
  { label: 'Seguridad', to: '/seguridad' },
  { label: 'Precios', to: '/pricing' },
  { label: 'Contacto', to: '/contact' },
];

const Header2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mode, setMode } = useTheme();
  const [open, setOpen] = useState(false);

  const isActive = (to) => (to === '/' ? location.pathname === '/' : location.pathname.startsWith(to));
  const go = (to) => { setOpen(false); navigate(to); };

  const navLink = (item, mobile = false) => {
    const active = isActive(item.to);
    return (
      <a
        key={item.to}
        onClick={() => go(item.to)}
        style={{
          position: 'relative',
          padding: mobile ? '13px 8px' : '9px 13px',
          font: `600 ${mobile ? '1.05rem' : '.95rem'} 'IBM Plex Mono'`,
          color: mobile ? 'var(--btn-ghost)' : 'var(--nav)',
          cursor: 'pointer',
          borderRadius: mobile ? 0 : 9,
          borderBottom: mobile ? '1px solid var(--border)' : 'none',
          display: 'block',
        }}
      >
        {item.label}
        {active && !mobile && (
          <span style={{ position: 'absolute', left: 13, right: 13, bottom: 3, height: 2, background: '#2F6BFF', borderRadius: 2 }} />
        )}
      </a>
    );
  };

  const Logo = (
    <a onClick={() => go('/')} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} aria-label="PaySlip — Inicio">
      <Logo2 size={38} />
    </a>
  );

  const ghostBtn = {
    padding: '10px 16px', font: "700 .95rem 'IBM Plex Mono'", color: 'var(--btn-ghost)',
    cursor: 'pointer', borderRadius: 10, border: '1.5px solid var(--border-strong)',
  };
  const primaryBtn = {
    padding: '11px 18px', font: "700 .95rem 'IBM Plex Mono'", color: '#fff', background: '#2F6BFF',
    cursor: 'pointer', borderRadius: 10, boxShadow: '0 8px 22px -6px rgba(47,107,255,.85)',
  };

  return (
    <header style={{ position: 'sticky', top: 0, zIndex: 60, backdropFilter: 'blur(14px)', background: 'var(--header-bg)', borderBottom: '1px solid var(--border)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '14px clamp(20px,5vw,40px)', display: 'flex', alignItems: 'center', gap: 20 }}>
        {Logo}

        {/* Nav desktop (≥1024px) */}
        <nav className="ls2-navdesk" style={{ marginLeft: 'auto', alignItems: 'center', gap: 2 }}>
          {NAV.map((n) => navLink(n))}
        </nav>
        <div className="ls2-navdesk" style={{ alignItems: 'center', gap: 10 }}>
          <ThemeToggle mode={mode} onChange={setMode} />
          <a onClick={() => go('/login')} style={ghostBtn}>Iniciar sesión</a>
          <a onClick={() => go('/register')} style={primaryBtn}>Prueba 15 días</a>
        </div>

        {/* Hamburguesa móvil (<1024px) */}
        <button
          className="ls2-navmob"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menú"
          style={{ marginLeft: 'auto', width: 44, height: 44, borderRadius: 11, border: '1.5px solid var(--border-strong)', background: 'var(--ghost-bg)', color: 'var(--btn-ghost)', cursor: 'pointer', display: 'grid', placeItems: 'center' }}
        >
          <Sym name={open ? 'close' : 'menu'} size={26} />
        </button>
      </div>

      {/* Panel móvil */}
      {open && (
        <div className="ls2-navmob" style={{ borderTop: '1px solid var(--border)', background: 'var(--bg)', padding: '12px clamp(20px,5vw,40px) 20px', flexDirection: 'column', gap: 2, animation: 'ls2-fadeIn .2s both' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 8px 14px', marginBottom: 6, borderBottom: '1px solid var(--border)' }}>
            <span style={{ font: "700 .82rem 'IBM Plex Mono'", letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--muted)' }}>Tema</span>
            <ThemeToggle mode={mode} onChange={setMode} />
          </div>
          {NAV.map((n) => navLink(n, true))}
          <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
            <a onClick={() => go('/login')} style={{ ...ghostBtn, flex: 1, textAlign: 'center' }}>Iniciar sesión</a>
            <a onClick={() => go('/register')} style={{ ...primaryBtn, flex: 1, textAlign: 'center' }}>Prueba 15 días</a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header2;
